/**
 * Builds a `withTimeout` wrapper that races a promise against a timer. When the timer wins first,
 * the returned promise rejects with `onTimeout()` (called fresh each time, so callers get a new
 * error/stack per timeout). The timer is cleared once the wrapped promise settles, so a
 * fast-resolving promise leaves no pending timeout behind.
 */
export const createTimeout =
  (onTimeout: () => unknown) =>
  <T>(promise: Promise<T>, millis: number): Promise<T> =>
    Promise.race([
      promise,
      new Promise<T>((_, reject) => {
        const id = setTimeout(() => reject(onTimeout()), millis);
        promise.then(
          () => clearTimeout(id),
          () => clearTimeout(id),
        );
      }),
    ]);
